package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 轮播容器：[PageView] 的特化，叠加首尾循环与自动播放。
 *
 * [nextPage] / [previousPage] 在 loop 为 true 时跨越边界回绕（末页 next → 首页，首页 prev → 末页）。
 * 自动播放仅记录配置；实际定时推进由后续阶段的 ScrollAnimator 接管（本阶段不引入独立 tick）。
 *
 * final：不再向下继承。注意因 [ScrollableContainer] 的自类型绑定在 PageView，本类自身的链式 setter
 * （loop / autoPlay / ...）显式返回 CarouselView，而继承自 PageView 的方法返回 PageView。
 */
class CarouselView private constructor() : PageView() {

    private var loopEnabled = true
    private var autoPlayEnabled = false
    private var autoPlayIntervalMsValue = AUTO_PLAY_INTERVAL_DEFAULT_MS

    override fun nextPage(): PageView {
        if (loopEnabled && pageCount() > 0 && currentPage() >= pageCount() - 1) {
            return setCurrentPage(0)
        }
        return super.nextPage()
    }

    override fun previousPage(): PageView {
        if (loopEnabled && pageCount() > 0 && currentPage() <= 0) {
            return setCurrentPage(pageCount() - 1)
        }
        return super.previousPage()
    }

    // -------- 轮播配置 --------

    fun loop(loop: Boolean): CarouselView {
        loopEnabled = loop
        return this
    }

    fun loop(): Boolean = loopEnabled

    fun autoPlay(autoPlay: Boolean): CarouselView {
        autoPlayEnabled = autoPlay
        return this
    }

    fun autoPlay(): Boolean = autoPlayEnabled

    fun autoPlayIntervalMs(ms: Int): CarouselView {
        autoPlayIntervalMsValue = maxOf(0, ms)
        return this
    }

    fun autoPlayIntervalMs(): Int = autoPlayIntervalMsValue

    companion object {
        /** 自动播放默认间隔（毫秒）。 */
        private const val AUTO_PLAY_INTERVAL_DEFAULT_MS = 3000

        /** 创建一个轮播容器。 */
        @JvmStatic
        fun create(): CarouselView = CarouselView()
    }
}
